import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { PASSWORD_REGEXP } from '@e3dc-react/shell/Libs/consts'
import { booleanSchema, FormInitializerReturnType } from 'src/Configuration/validation'
import { PasswordForm } from 'src/Elements/User/create-password/CreatePasswordForm'
import { InvitedUser, TokenValidFormData } from 'src/Elements/User/create-password/TokenValid'
import { object, ref, string } from 'yup'

/**
 * Initializes the form for setting the password of a new user.
 * @param user - InvitedUser
 * @returns initialValues and validationSchema for Password-Validation form
 */
export const usePasswordFormInitializer = (user?: InvitedUser): FormInitializerReturnType<PasswordForm, TokenValidFormData> => {
  const { t } = useCustomTranslation()
  const booleanSchemaWithTranslation = booleanSchema(t)
  const passwordRegExp = new RegExp(PASSWORD_REGEXP)
  const initialValues = {
    username: user?.username ?? '',
    eMail: user?.Anschrift?.Email ?? '',
    userLevel: user?.level ?? '',
    phoneNumber: user?.Anschrift?.Telefon ?? '',
    firstName: user?.Vorname ?? '',
    lastName: user?.Name ?? '',
    address: user?.Anschrift?.PlaceOR ?? '',
    zipCode: user?.Anschrift?.PLZ ?? '',
    city: user?.Anschrift?.Address ?? '',
    country: user?.Anschrift?.Land ?? '',
    company: undefined,
    companyName: user?.Firmen?.Name,
    ipin: user?.ipin ?? '',
    eMailNotification: user?.mailNotification ?? false,
    password: '',
    passwordRepeat: '',
    gdprAccepted: false,
    useShop: false,
    couponPermission: false,
  }

  const validationSchema = object().shape({
    password: string()
      .required(t('validations.form.password.is-required'))
      .min(8, t('shell.passwortReset.error.passwordShort'))
      .matches(passwordRegExp, t('shell.passwortReset.error.characters-missing')),
    passwordRepeat: string()
      .required(t('validations.form.password.is-required'))
      .min(8, t('shell.passwortReset.error.passwordShort'))
      .matches(passwordRegExp, t('shell.passwortReset.error.characters-missing'))
      .oneOf([ref('password'), ''], t('shell.passwortReset.error.passwordDiffer')),
    gdprAccepted: booleanSchemaWithTranslation({ hasToBeTrue: true }).required(t('validations.form.gdpr.is-required')),
  })
  return { initialValues, validationSchema }
}
